module.exports = __webpack_public_path__ + "img/1_no.4709ad91.svg";